import { render } from "./CreateContactModal.vue?vue&type=template&id=73bb2d3a&ts=true"
import script from "./CreateContactModal.vue?vue&type=script&lang=ts"
export * from "./CreateContactModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__